import * as Actions from '../../actions/inspection/type';

const initialState = {
  // get custom templates
  getCustomTemplateLoading: false,
  getCustomTemplates: [],
  getCustomTemplateError: '',

  // create custom template

  createCustomTemplateLoading: false,
  createCustomTemplate: '',
  createCustomTemplateError: '',

  // update custom template

  updateCustomTemplateLoading: false,
  updateCustomTemplate: '',
  updateCustomTemplateError: '',

  deleteTemplateLoading: false,
  deletedTemplated: '',
  deleteTemplateErr: '',
};

export const inspectionTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Custom Templates
    case Actions.GET_CUSTOM_TEMPLATES_REQUEST:
      return {
        ...state,
        getCustomTemplateLoading: true,
      };
    case Actions.GET_CUSTOM_TEMPLATES_SUCCESS:
      return {
        ...state,
        getCustomTemplateLoading: false,
        getCustomTemplates: action.payload?.data || [],
      };
    case Actions.GET_CUSTOM_TEMPLATES_FAIL:
      return {
        ...state,
        getCustomTemplateLoading: false,
        getCustomTemplateError: action.payload,
      };

    // delete inspection Templates
    case Actions.DELETE_INSPECTION_TEMPLATE_REQUEST:
      return {
        ...state,
        deleteTemplateLoading: true,
      };
    case Actions.DELETE_INSPECTION_TEMPLATE_SUCCESS:
      return {
        ...state,
        deleteTemplateLoading: false,
        deletedTemplated: action.payload?.data || {},
      };
    case Actions.DELETE_INSPECTION_TEMPLATE_FAIL:
      return {
        ...state,
        deleteTemplateLoading: false,
        deleteTemplateErr: action.payload,
      };

    case Actions.UPDATE_INSPECTION_TEMPLATE_LIST_ON_DELETE:
      const tempId = +action.payload?.id;
      const filteredList = state?.getCustomTemplates?.filter(
        (temp) => temp?.id !== tempId,
      );
      return {
        ...state,
        getCustomTemplates: filteredList,
      };

    case Actions.CLEAR_DELETE_INSPECTION_TEMPLATE_STATES:
      return {
        ...state,
        deleteTemplateLoading: false,
        deletedTemplated: '',
        deleteTemplateErr: '',
      };

    // Create Custom Template
    case Actions.CREATE_CUSTOM_TEMPLATE_REQUEST:
      return {
        ...state,
        createCustomTemplateLoading: true,
      };
    case Actions.CREATE_CUSTOM_TEMPLATE_SUCCESS:
      let templates = state.getCustomTemplates || [];
      const newTemplate = action.payload?.data || '';

      if (newTemplate?.id) {
        templates = [newTemplate, ...templates];
      }
      return {
        ...state,
        createCustomTemplateLoading: false,
        createCustomTemplate: action.payload || '',

        // also insert newly added template into getCustomTemplates list
        getCustomTemplates: templates,
      };
    case Actions.CREATE_CUSTOM_TEMPLATE_FAIL:
      return {
        ...state,
        createCustomTemplateLoading: false,
        createCustomTemplateError: action.payload,
      };

    // Update Custom Template
    case Actions.UPDATE_CUSTOM_TEMPLATE_REQUEST:
      return {
        ...state,
        updateCustomTemplateLoading: true,
      };
    case Actions.UPDATE_CUSTOM_TEMPLATE_SUCCESS:
      const templateList = state.getCustomTemplates || [];
      const updatedTemp = action.payload?.data || '';

      const foundIndex = templateList.findIndex((x) => x.id === updatedTemp.id);
      if (foundIndex > -1) {
        templateList[foundIndex] = {
          ...templateList[foundIndex],
          ...updatedTemp,
        };
        templateList[foundIndex].list = updatedTemp?.list || [];
      }

      return {
        ...state,
        updateCustomTemplateLoading: false,
        updateCustomTemplate: action.payload || '',

        // also update updated template into getCustomTemplates list
        getCustomTemplates: templateList,
      };
    case Actions.UPDATE_CUSTOM_TEMPLATE_FAIL:
      return {
        ...state,
        updateCustomTemplateLoading: false,
        updateCustomTemplateError: action.payload,
      };

    // Clear Template States
    case Actions.CLEAR_CUSTOM_TEMPLATE_STATES:
      return {
        ...state,
        getCustomTemplateLoading: false,
        getCustomTemplateError: '',

        createCustomTemplateLoading: false,
        createCustomTemplate: '',
        createCustomTemplateError: '',

        updateCustomTemplateLoading: false,
        updateCustomTemplate: '',
        updateCustomTemplateError: '',
      };

    default:
      return state;
  }
};
